module.exports = __webpack_public_path__ + "static/img/bg_coupon_two_grey_used.34b4de9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_two_grey_used.png
// module id = uAHT
// module chunks = 0